/**
 *  @class
 *  @function ImageHotspots
 */
if (!customElements.get('image-hotspots')) {
  class ImageHotspots extends HTMLElement {
    constructor() {
      super();

      this.dots = this.querySelectorAll('.image-hotspots--pin');
      this.buttons = this.querySelectorAll('.image-hotspots--pin-button');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.activeDot = false;

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', this.onClick.bind(this, dot));
        dot.addEventListener('touchstart', this.onClick.bind(this, dot));
      });
    }
    
    onClick(dot) {

      this.dots.forEach((thedot, index) => {
        if (dot == thedot) {
        
          let slideIndex = index;
          
          let owlIndex = slideIndex || 0;
          if($('.hotsports_pdp_content') || $('.hotspots-popup_container')){

            $('.hotsports_pdp_content').find(`.owl-stage-outer`).trigger('to.owl.carousel', owlIndex);
            setTimeout(() => {
              theme.loadCarousels($('.hotspots-popup_container'));
              $('.hotspots-popup_container').find(`.owl-stage-outer`).trigger('to.owl.carousel', owlIndex);
              // console.log("owlIndex",owlIndex);
            },200);
          }
           
          // $('.slick-slide')[1].slickGoTo(slideIndex);
          return;
        }
        thedot.classList.remove('active');
        
      });
      this.activeDot = dot;
      // this.checkCardPosition();
      dot.classList.toggle('active');
      if (!dot.classList.contains('active')) {
        setTimeout(() => {
          dot.classList.remove('bottom-dot');
          dot.style.setProperty('--content-offset', '0px');
        }, 350);
      }

    }
  }
  customElements.define('image-hotspots', ImageHotspots);
}
